export default __webpack_public_path__ + "static/emblem-black-c32f6493f4b5a50ab1af3fffb8738fed.svg";